import HRLayout from "../hr/HRLayout";
import useHRCopy from "../hr/i18n/useHRCopy";
import Reveal from "../hr/components/Reveal";
import PageHeader from "../hr/components/PageHeader";
import ServiceRecord from "../hr/components/ServiceRecord";
import DOORS from "../hr/components/doorImages";
import ContactForm from "../components/ContactForm";

export default function HizmetlerimPage() {
  const copy = useHRCopy();
  const t = copy.pages.hizmetler;

  return (
    <HRLayout>
      <PageHeader title={t.title} lede={t.lede} />

      {/* Two services, two full-width records. The index numbers are real
          here: this is the site's enumerated list of what is offered.
          Kept on paper so the white record panels stay raised — the platinum
          contact band below supplies the tonal change. */}
      <section className="border-t border-line px-6 sm:px-10 lg:px-16 py-16 lg:py-20">
        <div className="max-w-[1600px] mx-auto space-y-6 lg:space-y-8">
        {t.cards.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.09}>
            <ServiceRecord
              img={DOORS[i].img}
              imgPosition={DOORS[i].pos}
              index={`0${i + 1} / 0${t.cards.length}`}
              title={c.title}
              body={c.body}
              href={c.href}
              cta={c.cta}
              flip={i % 2 === 1}
            />
          </Reveal>
        ))}
        </div>
      </section>

      <ContactForm title={t.contactLead.title} body={t.contactLead.body} />
    </HRLayout>
  );
}
